/* eslint-disable prefer-destructuring */
/**

Coded by www.techhighway.ca

*/

// @mui material components
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";

export default styled(CircularProgress)(({ theme }) => {
  const { palette, functions } = theme;
  const { grey, transparent } = palette;

  return {};
});
